<template>
  <v-data-table
    :headers="columnKeys"
    :items="items"
    :pagination.sync="pagination"
    :rows-per-page-items="pagination.pageList"
    :total-items="totalItems"
    @update:pagination="changePage"
    class="elevation-1"
    :loading="loading">
    <template slot="headers" slot-scope="props">
      <tr>
        <th v-for="(header, i) in props.headers.filter(h=>!h.hidden)"
            :key="i"
            :class="['column sortable', pagination.descending ? 'desc'
                            : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            :width="header.width"
            @click="changeSort(header.value)">
          <v-icon small>arrow_upward</v-icon>
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template slot="items" slot-scope="props" >
      <tr :style="`background-color: ${ props.item.color ? props.item.color : '#fafafa' };`">
        <td class="text-xs-center"
            v-for="col in columnKeys.filter(h=>!h.hidden)" :key="col.value">
          <v-btn :class="col.color ? col.color : 'red'" dark v-if="col.isEvent"
                 @click.stop="cellEvent(col.value, props.item)">{{col.text}}</v-btn>
          <v-btn flat text v-else-if="col.isTextEvent"
                 @click.stop="cellEvent(col.value, props.item)">{{props.item[col.value]}}</v-btn>
          <div v-else-if="col.isSelect" :style="`background-color: ${props.item[col.key] === 1 || props.item[col.key] === true ? '#28a745': '#ffc107'}; font-weight:700; padding: 2px; border-radius:5px; color:white;`">
            <span>{{ getSelectList(col, props.item) }}</span>
          </div>
          <span v-else-if="col.isSelectText">{{ getSelectList(col, props.item) }}</span>
          <span v-else-if="col.colorText" :style="{ color: props.item.textColor}">{{ props.item[col.value] }}
          </span>
          <span v-else>{{ getValue(col, props.item[col.value])}}</span>
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="reloadData">重新整理</v-btn>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: 'TableView',
    props: {
      columnKeys: Array,
      items: Array,
      loading: Boolean,
      // pagination: Object,
      totalItems: Number
    },
    data(){
      return {
        pagination: {
          sortBy: "createdDate",
          descending: "desc",
          page: 1,
          length: 5,
          pageList: [5, 25 , 50, 100]
        },
      }
    },
    methods:{
      getSelectList(col, option){
        const find = col.options.find(item=>`${item.key}` === option[col.value] || item.key === option[col.value]);
        if (find){
          return find.text;
        }
        return '--'
      },
      changePage(page){
        console.log(`page ${JSON.stringify(page)}`);
        this.$emit('changePage', page);
      },
      changeSort(column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
        this.$emit('changeSort', this.pagination);
      },
      cellEvent(key, item){
        this.$emit('cellEvent', {key:key, item: item });
      },
      getValue(col, text){
        if (col.emptyValue === ''){
          return text;
        } else {
          if (!text || text === ''){
            return col.emptyValue;
          }
          return text;
        }
      },
      reloadData() { // 重整
        this.$emit('handleLoadData');
      },
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TableView.vue